import { render, staticRenderFns } from "./NotificationDropdown.vue?vue&type=template&id=51213b64&scoped=true&"
import script from "./NotificationDropdown.vue?vue&type=script&lang=js&"
export * from "./NotificationDropdown.vue?vue&type=script&lang=js&"
import style0 from "./NotificationDropdown.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NotificationDropdown.vue?vue&type=style&index=1&id=51213b64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51213b64",
  null
  
)

export default component.exports